// Non-ASCII spaces (NBSP and the other Unicode space separators), line/paragraph separators and NEL, zero-width and
// invisible format characters, bidi marks and the soft hyphen, which a copy from Outlook, Excel, a web page or a PDF
// can carry into an address. None of them can be part of a valid address, and the browser only strips ASCII
// whitespace from an <input type="email">. Listed explicitly, character for character the same as
// StringExtensions.CleanEmailAddress, so the two sides agree whatever each runtime's trim() strips: once these are
// gone, only ASCII whitespace is left for trim(), and both runtimes trim that the same way.
const INVISIBLE_CHARACTERS =
  /[\u0085\u00A0\u00AD\u061C\u1680\u180E\u2000-\u200F\u2028-\u202F\u205F-\u2064\u2066-\u2069\u3000\uFEFF]/g;

/**
 * Removes invisible characters anywhere in an email address and trims whitespace from its ends.
 * Anything else (an inner ASCII space, "Name <address>", accented letters) is left for the validator to reject.
 * Keep in step with StringExtensions.CleanEmailAddress on the server.
 */
export function cleanEmailAddress(value: string): string {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replace(INVISIBLE_CHARACTERS, '').trim();
}
